export const authUserSelector = state => state.entities.authUser;
